export default {"src":"/_next/static/media/logo-full.ff83acf2.svg","height":32,"width":90,"blurWidth":0,"blurHeight":0};